import React, { ReactElement } from 'react';
import {
  Table, Tbody, Td, Th, Thead, Tr,
} from 'idsk-react-components';
import LdapItem from '../../../model/LdapItem';
import './searchLdapDataResultTable.scss';

interface Props {
  label: string;
  data: LdapItem[];
  setLdapItem: (ldapItem: LdapItem) => void;
  setSearchToken: (searchTokens: string) => void;
  clearFieldErrorMessage: (fieldName: string) => void;
  isPouzivatel?: boolean;
}

const SearchLdapDataResultTable = ({
  label,
  data,
  setLdapItem,
  setSearchToken,
  clearFieldErrorMessage,
  isPouzivatel,
}: Props): ReactElement => (
  <div className="search-ldap-data__result-table">
    <Table>
      <Thead>
        {isPouzivatel ? (
          <Tr>
            <Th>Meno</Th>
            <Th>ID</Th>
          </Tr>
        )
          : (
            <Tr>
              <Th>Skratka</Th>
              <Th>Názov</Th>
            </Tr>
          )}
      </Thead>
      <Tbody>
        {data.map(item => (
          <Tr
            key={item.uuid}
            onClick={() => {
              setLdapItem(item);
              setSearchToken('');
              clearFieldErrorMessage(label);
            }}
          >
            {isPouzivatel ? (
              <>
                <Td>{item.fullName}</Td>
                <Td>{item.shortName}</Td>
              </>
            )
              : (
                <>
                  <Td>{item.shortName}</Td>
                  <Td>{item.fullName}</Td>
                </>
              )}
          </Tr>
        ))}
      </Tbody>
    </Table>
  </div>
);

export default SearchLdapDataResultTable;
